export default __webpack_public_path__ + "static/media/login_top.fc86dc83.png";